(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["vo-request"] && !Shopify.designMode) return;
  try {
    (() => {
    /* Non-modal on purpose: a modal dialog sits in the top layer and would hide Shopify's hCaptcha challenge */
    let lastOpener = null;
    const open = (dialog, type, opener) => {
      if (type) {
        const title = dialog.querySelector('[data-vo-request-title]');
        const field = dialog.querySelector('[data-vo-request-type]');
        if (title) title.textContent = type;
        if (field) field.value = type;
      }
      const mode = opener?.dataset.mode || 'default';
      dialog.querySelectorAll('[data-vo-mode]').forEach((set) => {
        const on = set.dataset.voMode === mode;
        set.hidden = !on;
        set.disabled = !on;
      });
      lastOpener = opener || null;
      /* Lift out of the section's stacking context so the sticky header can't cover it */
      if (dialog.parentElement !== document.body) document.body.append(dialog);
      if (!dialog.open) dialog.show();
      document.documentElement.style.overflow = 'hidden';
      (dialog.querySelector('input:not([type=hidden]), .vo-request__submit') || dialog).focus({ preventScroll: true });
    };
    const close = (dialog) => {
      if (!dialog?.open) return;
      dialog.close();
      document.documentElement.style.overflow = '';
      lastOpener?.focus({ preventScroll: true });
    };
    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-vo-request-open]');
      if (opener) {
        const dialog = document.getElementById(opener.dataset.voRequestOpen);
        if (dialog) open(dialog, opener.dataset.type, opener);
        return;
      }
      if (event.target.closest('[data-vo-request-close]')) {
        close(event.target.closest('dialog'));
        return;
      }
      const dialog = document.querySelector('.vo-request__dialog[open]');
      if (dialog && !dialog.contains(event.target) && !event.target.closest('iframe, [class*="hcaptcha"]')) close(dialog);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close(document.querySelector('.vo-request__dialog[open]'));
    });
    const reopen = () => {
      document.querySelectorAll('.vo-request__dialog').forEach((dialog) => {
        if (dialog.querySelector('[data-vo-request-autoopen]')) open(dialog);
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reopen);
    else reopen();
  })();
  } catch(e) { console.error(e); }
})();

})();
